'use client';
import { getOptionLabel, getUniqueId, SidebarOption } from './sidebar.utils';
import { useSidebarFilter } from './useSidebarFilter';

const OptionFilterList = ({
  options,
  paramName,
}: {
  options?: SidebarOption[];
  paramName: string;
}) => {
  const { isChecked, handleCheckboxChange } = useSidebarFilter();
  const isSingleSelect = paramName === 'dayAgo';
  const inputType = isSingleSelect ? 'radio' : 'checkbox';

  return (
    <ul className="flex flex-col gap-4">
      {(options ?? []).map((option, optionIndex) => (
        <li key={optionIndex}>
          <div className="flex gap-2 cursor-pointer">
            <input
              type={inputType}
              name={isSingleSelect ? `group-${paramName}` : undefined}
              className="shrink-0"
              id={getUniqueId(paramName, String(option.id))}
              checked={isChecked(paramName, String(option.id))}
              onChange={(e) =>
                handleCheckboxChange(
                  paramName,
                  String(option.id),
                  e.target.checked
                )
              }
            />
            <label
              htmlFor={getUniqueId(paramName, String(option.id))}
              className="leading-5 cursor-pointer select-none"
            >
              {getOptionLabel(option)}
            </label>
          </div>
          {option.children && option.children.length > 0 && (
            <ul className="flex flex-col gap-2 ml-4 pt-2">
              {option.children.map((child, childIndex) => (
                <li key={childIndex} className="flex gap-2 cursor-pointer">
                  <input
                    type={inputType}
                    name={isSingleSelect ? `group-${paramName}` : undefined}
                    className="shrink-0"
                    id={getUniqueId(paramName, String(child.id))}
                    checked={isChecked(paramName, String(child.id))}
                    onChange={(e) =>
                      handleCheckboxChange(
                        paramName,
                        String(child.id),
                        e.target.checked
                      )
                    }
                  />
                  <label
                    htmlFor={getUniqueId(paramName, String(child.id))}
                    className="leading-5 cursor-pointer select-none"
                  >
                    {getOptionLabel(child)}
                  </label>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
};

export default OptionFilterList;
